import {
  Sparkles, Heart, Sun, Moon, Star, Send, Ship, Home, Cloud, Spline,
  RotateCcw, Flower, Scissors, MessagesSquare, Bird, Baby, Briefcase,
  Shield, Feather, Dog, Building, Trees, Mountain, Milestone, KeyRound,
  Leaf, Circle, Book, Anchor, HeartHandshake, Globe, MoonStar, Crown,
  WandSparkles, CircleDot, Flame, Wine, Milk, Swords, Coins, Scale, Clover,
} from "lucide-react";

const MAP = {
  sparkles: Sparkles, heart: Heart, sun: Sun, moon: Moon, star: Star,
  send: Send, ship: Ship, home: Home, cloud: Cloud, spline: Spline,
  "rotate-ccw": RotateCcw, flower: Flower, scissors: Scissors,
  "messages-square": MessagesSquare, bird: Bird, baby: Baby, briefcase: Briefcase,
  shield: Shield, feather: Feather, dog: Dog, building: Building, trees: Trees,
  mountain: Mountain, milestone: Milestone, "key-round": KeyRound, leaf: Leaf,
  circle: Circle, book: Book, anchor: Anchor, "heart-handshake": HeartHandshake,
  globe: Globe, "moon-star": MoonStar, crown: Crown, "wand-sparkles": WandSparkles,
  "circle-dot": CircleDot, flame: Flame, wine: Wine, milk: Milk, swords: Swords,
  coins: Coins, scale: Scale, clover: Clover,
};

export const iconFor = (name) => MAP[name] || Sparkles;
